<div [formGroup]="dialogForm">
  <div class="modal-content">
    <div class="modal-header">
      <h6 class="modal-title pull-left" id="tittle">{{ title }}</h6>
      <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <em class="icon-close"></em>
      </button>
    </div>
    <div class="modal-body admin-form">
      <div class="container-fluid">
        <div class="form-group">
          <!-- Download Template Card -->
          <div class="row mb-4">
            <div class="col-md-12">
              <div class="download-template-card">
                <div class="template-info-wrapper">
                  <img class="excel-icon" alt="Import excel template" [src]="assetPath + '/template-excel.svg'" />
                  <div class="text-container">
                    <span class="template-title">{{ templateName }}</span>
                    <span class="template-subtitle">Use this template to import your data</span>
                  </div>
                </div>
                <button
                  type="button"
                  id="btn-download"
                  data-id="btn-download"
                  class="btn btn-primary"
                  (click)="onDownloadTemplate()"
                >
                  <em class="icon-download"></em>
                  Download
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-3">
              <label htmlFor="inputFile">{{ fileTitle }}</label>
              <div *ngIf="dialogForm?.value?.file; else noFiles">
                <div class="image-container">
                  <input
                    id="inputFile"
                    data-id="inputFile"
                    class="form-control cursor-default"
                    readonly
                    value="{{ dialogForm?.value?.file.name }}"
                  />
                  <em *ngIf="dialogForm?.value?.file.name" class="icon-close-mini" (click)="clearFile()"></em>
                </div>
              </div>
              <ng-template #noFiles>
                <div class="upload-container text-center form-control" [ngClass]="{ 'is-invalid': false }">
                  <input
                    data-id="uploadFile"
                    id="uploadFile"
                    class="d-none"
                    #uploadInput
                    type="file"
                    (change)="importItems($event)"
                  />
                  <div class="input-group" (click)="uploadInput.click()">
                    <input
                      placeholder="No File Chosen"
                      id="input-file"
                      data-id="input-file"
                      class="form-control upload-input cursor-default"
                      readonly
                    />
                    <em class="icon-upload"></em>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="error-row" *ngIf="dialogForm.get('file').errors || isValidateSuccess">
            <div class="col-md">
              <div class="alert-success form-group mb-0 row" *ngIf="isValidateSuccess">
                <div id="successMessage" data-id="successMessage">
                  The data has been uploaded. Are you sure you want to submit?
                </div>
              </div>
              <div
                class="row alert-danger align-content-between justify-content-between"
                *ngIf="dialogForm.get('file').errors?.errorMessage"
              >
                <div
                  class="p-0 error-message"
                  id="errorMessage"
                  data-id="errorMessage"
                  [ngClass]="errorFile ? 'col-md-10' : 'col-md-12'"
                >
                  {{ dialogForm.get('file').errors?.errorMessage }}
                </div>
                <div
                  id="errorDownload"
                  data-id="errorDownload"
                  class="col-md-2 p-0 download-template-error"
                  *ngIf="errorFile"
                  (click)="onDownloadTemplateError()"
                >
                  Download
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        data-id="btn-cancel"
        id="btn-cancel"
        name="btn-cancel"
        class="btn btn-standard mr-2"
        (click)="closeModal()"
      >
        Cancel
      </button>
      <button
        type="button"
        data-id="btn-ok"
        id="btn-ok"
        name="btn-ok"
        class="btn btn-primary"
        appPreventDoubleClick
        [disabled]="dialogForm.invalid"
        (click)="onSubmit()"
      >
        {{ okTitle }}
      </button>
    </div>
  </div>
</div>
